module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('div', {
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/title.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1 pb",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Minding Miss Manners")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("®")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("copyright © 2020 by Judith Martin. All rights reserved. ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("No part of this book may be used or reproduced in any manner whatsoever without written permission except in the case of reprints in the context of reviews. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1 t"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Andrews McMeel Publishing")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("a division of Andrews McMeel Universal")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("1130 Walnut Street, Kansas City, Missouri 64106")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1 t"
  }, [_c('a', {
    attrs: {
      "href": "http://www.andrewsmcmeel.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("www.andrewsmcmeel.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1 t"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ISBN: ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("978-1-5248-6277-0")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1 t"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Library of Congress Control Number: 2019954934 ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1 t"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Editor: Allison Adler")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Art Director: Julie Phillips")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Production Editor: Margaret Daniels")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Production Manager: Carol Coe")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Ebook Developer: Kristen Minter")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1 t"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Attention: Schools and Businesses")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Andrews McMeel books are available at quantity discounts with bulk purchase for educational, business, or sales promotional use. For information, please  e-mail the Andrews McMeel Publishing Special Sales Department: ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:specialsales@amuniversal.com"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("specialsales@amuniversal.com")])]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(".")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "_CN-"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ntroduction")])]), _vm._v(" "), _c('p', {
    staticClass: "init-para-1"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("W")]), _vm._v("e are a freedom-loving people. Even the terminally ladylike Miss Manners is fond of having her own way, as you may have noticed. And now we have achieved the etiquette-free society of our dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Well, of your dreams; not hers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s right there on the Internet, where you can almost always get away with saying anything, no matter the consequences to other people. And it is creeping into real life. You must have observed a certain lack of civility in the society.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is not entirely new. It is some decades since the enlightened child-rearing technique, or lack of one, has consisted of “Just be yourself, and don’t care what other people think.” The intention may be to say, “Stand up for what you know is right, even in the face of disapproval.” But it comes across as “Do what suits you and never mind how it affects anyone else.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A philosophically inclined child may wonder exactly how “self” is defined, let alone discovered. A sly one might consider this an endorsement of selfishness. And none of them falls for the idea of being indifferent to being liked by other children. Not one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nevertheless, here we are, with a society largely populated by people who are just being themselves, unfiltered by the extra-legal system of voluntary restraint to avoid antagonizing others unnecessarily: a system known as etiquette.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So why isn’t everyone happy? Why is this not a haven of goodwill? After all, you are:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Free to tell off people whom you don’t like.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Free to shout insults at strangers in the street.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Free to air socially disapproved opinions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Free to use socially disapproved words.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Free to pressure people to give you money.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And we patriotic Americans should defend your legal right to do so. But must you?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You see, there is a catch. It is that those objectionable other people are equally free to make life miserable for you and anyone else. A new era of freedom to be loutish, pushy, vicious, and hateful is upon us.")]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "SMALL-PQ"
  }, [_vm._v("So why isn’t everyone happy?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That an etiquette-free society would be a joyous, or even livable, one must be the biggest social hoax since it was declared that America’s basic problem was sexual puritanism, and if all were freely acting on their desires, everyone would be happy, and there would be no more sex crimes. We are now forced to see how that has played out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rather, you should think of the necessity to refrain from antagonizing others as a sort of Civility Tax. No one likes to pay taxes, but reasonable people know that they must in order to support the common good. It’s called civilization.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Are you willing to trade:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not using foul language for not having your children use it about you?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Committing to answering invitations and appearing or not appearing as promised for knowing how many people will attend your events?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not telling people how stupid their opinions are for not hearing how stupid they think yours are?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thinking before you tweet for not having to apologize afterward?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Waiting your turn for not having people push ahead of you?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not insulting other people’s heritages for their not insulting yours?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not begging from others for not having them always dunning you?")]), _vm._v(" "), _c('p', {
    staticClass: "dots"
  }, [_vm._v("• • •")]), _vm._v(" "), _c('p', {
    staticClass: "dear3-dots"
  }, [_c('span', {
    staticClass: "dear--- _idGenCharOverride-1"
  }, [_vm._v("Dear Miss Manners")]), _c('span', {
    staticClass: "dear--- CharOverride-6"
  }, [_vm._v("—")]), _vm._v("Why are we always looking for polite ways to address someone else’s impoliteness? Why must we feel guilty about offending the offender? Why do we walk on eggshells and agonize over how to approach a  person who is completely out of line in how they may have treated, talked to, or behaved in any given situation? ")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After all, it is not my fault that the person has behaved like a total ass.")]), _vm._v(" "), _c('p', {
    staticClass: "gentle-reader3"
  }, [_c('span', {
    staticClass: "dear--- _idGenCharOverride-1"
  }, [_vm._v("Gentle Reader")]), _c('span', {
    staticClass: "dear--- CharOverride-6"
  }, [_vm._v("—")]), _vm._v("And you admire that person so much that you want to act the same way?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miss Manners will attempt to make politeness more palatable by offering a few exemptions. She is not going to let you off from sending letters of thanks, answering invitations, and refraining from telling people your honestly demeaning opinion of them. But—you don’t have to:")]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("Hug your colleagues.")]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("Help cater your friends’ dinner parties.")]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("Allow your guests to dictate the menu.")]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("Answer nosy questions.")]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("Subsidize luxuries for the solvent.")]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("Buy presents for your boss.")]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("Stay on the telephone with telemarketers.")]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("Continue to give presents to people who don’t acknowledge them.")]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("Have a ring to be engaged.")]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("Give or attend multiple bridal or baby showers.")]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("Give a series of presents to the same couple who are having a series of parties.")]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("Go into debt for a lavish wedding.")]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("Throw a party for someone who asked you to do so.")]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("Buy things you don’t want because your friends or their children are selling them.")]), _vm._v(" "), _c('p', {
    staticClass: "BL"
  }, [_vm._v("Respond to everyone’s inane or vainglorious postings.")]), _vm._v(" "), _c('p', {
    staticClass: "BL _idGenParaOverride-1"
  }, [_vm._v("Put teaspoons on the table unless you are serving tea.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d7763b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MissManners_epub.vue
// module id = 57
// module chunks = 0